module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/onlinestore/braveshop_bravenet_website.png";